import { forwardRef, Ref } from 'react'
import { Position } from '../../types'
import { useVisiblePositionPercent } from '../hooks/useVisiblePositionPercent'
import { PositionMilliseconds } from '../components/PositionMilliseconds'
import classNames from 'classnames'
import './TimelineLabel.scss'

interface Props {
  position: Position
  color?: 'accent' | 'blue'
}

export const TimelineLabel = forwardRef(
  ({ position, color = 'accent' }: Props, ref: Ref<HTMLDivElement> | undefined) => {
    const percent = useVisiblePositionPercent(position)

    return (
      <div
        className={classNames('TimelineLabel', {
          '-blue': color === 'blue',
        })}
        style={{ left: `${percent}%` }}
        ref={ref}
      >
        <PositionMilliseconds position={position} />
      </div>
    )
  },
)
